export enum NavItemAccessor {
  Header = 'header',
  HeaderBreadcrumb = 'header-breadcrumb',
  Separator = 'separator',
  Unnavigable = 'unnavigable',
  Unselectable = 'unselectable',
  WithoutActiveState = 'without-active-state',
}
